import { Skeleton, SkeletonItem } from '@capsicum/common-web';
import styled, { useTheme } from 'styled-components';

export const SkeletonEventAuctions = () => {
	const { border, colors, sizing } = useTheme();

	const radius = parseInt(border.radius.large['border-radius']);
	const radiusSmall = parseInt(border.radius.small['border-radius']);

	return (
		<S.Layout>
			<S.TitleWrapper>
				<div>
					<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
						<SkeletonItem height={parseInt(sizing.medium)} width={140} />
					</Skeleton>
				</div>
			</S.TitleWrapper>
			<S.AuctionsWrapper>
				{[...new Array(10)].map((value, index) => (
					<S.CardWrapper key={index}>
						<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
							<S.ImageSkeleton height={186} />
						</Skeleton>
						<S.DetailContainer>
							<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
								<SkeletonItem borderRadius={radius} height={20} width={141} />
							</Skeleton>
							<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
								<SkeletonItem borderRadius={radiusSmall} height={20} width={48} />
							</Skeleton>
							<Skeleton baseColor={colors.skeleton.default} highlightColor={colors.skeleton.highlight}>
								<SkeletonItem borderRadius={radiusSmall} height={69} width={141} />
							</Skeleton>
						</S.DetailContainer>
					</S.CardWrapper>
				))}
			</S.AuctionsWrapper>
		</S.Layout>
	);
};

namespace S {
	export const Layout = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xlarge};
		margin-top: ${({ theme }) => theme.spacings.xlarge};
	`;

	export const TitleWrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	`;

	export const AuctionsWrapper = styled.div`
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;

	export const ImageSkeleton = styled(SkeletonItem)`
		${({ theme }) => theme.border.radius.mediumTop};
	`;

	export const CardWrapper = styled.div`
		max-width: 173px;
		background: ${({ theme }) => theme.colors.backgrounds.main.container};
		${({ theme }) => theme.border.radius.medium};
	`;

	export const DetailContainer = styled.div`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.small};
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
